import { AxiosError } from 'axios'

import { StoreState } from '@shared/models/interfaces/store'

export const hasFailed = <T>(model?: StoreState<T>) => {
  return Boolean(model?.status?.fail)
}

export const hasSucceded = <T>(model?: StoreState<T>) => {
  return Boolean(model?.status?.success)
}

export const isPending = <T>(model?: StoreState<T>) => {
  return Boolean(model?.status?.pending)
}

export const getError = <T>(model?: StoreState<T>) => {
  const error = (model?.status.error ?? {}) as AxiosError
  const { response } = error

  if (!response) {
    return
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return response.data as Error
}

export const isEmpty = <T>(model?: StoreState<T>) => {
  if (model?.data) {
    if (Array.isArray(model?.data)) {
      return model?.data.length === 0
    }

    if (typeof model.data === 'object') {
      return Object.keys(model.data).length === 0
    }

    return false
  } else {
    return true
  }
}
